import type { CommunicationInboxItem } from "@/types/communications";
import type { TelegramChat, TelegramMessage } from "@/types/telegram";

export function telegramChatToInboxItem(chat: TelegramChat): CommunicationInboxItem {
  return {
    id: chat.id,
    subject: chat.title,
    from: chat.type || "chat",
    date: chat.lastMessageDate || new Date().toISOString(),
    preview: chat.lastMessagePreview || "",
    type: chat.type,
    read: !chat.unreadCount,
  };
}

export function telegramMessageToInboxItem(message: TelegramMessage): CommunicationInboxItem {
  return {
    id: message.id,
    subject: message.subject,
    from: message.from,
    to: message.to,
    date: message.date,
    preview: message.preview,
    read: message.read,
  };
}

export function telegramMessagesToInboxItems(messages: TelegramMessage[]): CommunicationInboxItem[] {
  return messages.map(telegramMessageToInboxItem);
}
